// extracted by mini-css-extract-plugin
export default {"caret":"styles__caret___2VxAd"};